import React, { Component } from 'react';
import { connect } from 'react-redux'
import styled from 'styled-components';
import validator from "validator";


import {setGiftAmount} from '../Actions'
import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import PrimaryButton from "../Components/PrimaryButton";
import {withRouter} from "react-router-dom";
import {toast} from "react-toastify";
import ParagraphText from "../Components/ParagraphText";
import TopContent from "../Components/TopContent";
import CurrencyInput from "../Components/CurrencyInput";
import {getUSDfromBTC, getBTCfromUSD} from "../Helpers/conversion";
import GiftAmount from "../Components/GiftAmount";

const SideBySide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

class BudgetPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usd: 0,
    }
  }
  componentDidMount() {
    if(this.props.wallet.address) {
      return this.props.history.push('/verify');
    }
    if(!this.props.giftAmount) {
      this.props.dispatch(setGiftAmount({
        giftAmount: 0.00
      }));
    } else {
      this.setState({usd: getUSDfromBTC(this.props.giftAmount, this.props.rates)});
    }
  }
  componentWillReceiveProps(newProps) {
    if(this.state.usd === 0) {
      this.setState({usd: getUSDfromBTC(newProps.giftAmount, newProps.rates)});
    }
  }
  onChangeBTC(event) {
    const typedAmount = event.target.value;
    this.setState({
      usd: getUSDfromBTC(typedAmount, this.props.rates)
    });
    this.props.dispatch(setGiftAmount({
      giftAmount: typedAmount
    }));
  }
  onChangeUSD(event) {
    const typedAmount = event.target.value;
    this.setState({
      usd: typedAmount
    });

    this.props.dispatch(setGiftAmount({
      giftAmount: getBTCfromUSD(typedAmount, this.props.rates)
    }));
  }
  validAmount(event) {
    let error = null;
    if(!this.props.giftAmount || !parseFloat(this.props.giftAmount)) {
      error = 'Please set a valid gift amount';
    } else if ( this.props.giftAmount < parseFloat(process.env.REACT_APP_MIN_GIFT_AMT)) {
      error = `Minimum gift is currently BTC ${process.env.REACT_APP_MIN_GIFT_AMT}`;
    } else if ( this.props.giftAmount > parseFloat(process.env.REACT_APP_MAX_GIFT_AMT)) {
      error = `Maximum gift is currently BTC ${process.env.REACT_APP_MAX_GIFT_AMT}`;
    }

    if(error) {
      toast.info(error);
      return event.preventDefault(error);
    }
  }
  render() {
    const emailText = this.props.recipientEmail && validator.isEmail(this.props.recipientEmail) ?
      ` to ${this.props.recipientEmail}` : '';

    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <div className="spacer-40px" />
            <Centered>
              <TitleText>Budget</TitleText>
              <div className="spacer-20px" />
              <ParagraphText>How much Bitcoin would you like to send{emailText}?</ParagraphText>

              <div className="spacer-40px" />
              <SideBySide>
                <CurrencyInput
                  type="number"
                  min="0.00"
                  max="0.1"
                  step="0.0001"
                  placeholder="0.005"
                  onBlur={(e) => this.onChangeBTC(e)}
                  onChange={(e) => this.onChangeBTC(e)}
                  onKeyPress={(e) => this.onChangeBTC(e)}
                  value={this.props.giftAmount}
                  currency={'BTC'}
                  name="btc-gift-amount"
                />
                <div>&nbsp;&#8652;&nbsp;</div>
                <CurrencyInput
                  type="number"
                  placeholder="20.00"
                  onBlur={(e) => this.onChangeUSD(e)}
                  onChange={(e) => this.onChangeUSD(e)}
                  onKeyPress={(e) => this.onChangeUSD(e)}
                  value={this.state.usd}
                  currency={'USD'}
                  name="usd-gift-amount"
                />
              </SideBySide>
              <div className="spacer-20px" />
              <ParagraphText>Amount:&nbsp;
                <ParagraphText bold>
                  <GiftAmount/>
                </ParagraphText>
              </ParagraphText>
              <div className="spacer-40px" />
              <PrimaryButton to="/theme" onClick={this.validAmount.bind(this)} styles={'align-self: center;'}>Theme →</PrimaryButton>
              <div className="spacer-80px" />
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
  giftAmount: state.gift.giftAmount,
  wallet: state.wallet,
  rates: state.conversionRates.rates,
  ratesUpdated: state.conversionRates.lastUpdated,
});

export default connect(mapStateToProps)(withRouter(BudgetPage));


// WEBPACK FOOTER //
// ./src/Pages/BudgetPage.js